import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { memo, useCallback, useState } from 'react';
import { SortableCards } from 'console/shared/components/features/sortable-cards';
import { SwiperWithModal } from 'console/shared/components/modals/swiper';
import { HeatingCircuitWidget } from 'console/shared/components/dialogs/heating-circuit-widget';
import { HeatingCircuitView } from './heating-circuit';
import { SwipableModalHeader } from '../../modals/swipable/header';
import { useBooleanState } from 'shared/hooks/state/boolean';
export const HeatingCircuits = memo(function HeatingCircuits(props) {
    const { config, panel_key } = props;
    const [opened, close, open] = useBooleanState(false);
    const [initial_slide, setInitialSlide] = useState(0);
    const onCloseSlider = useCallback(() => {
        close();
        setInitialSlide(0);
    }, [close, setInitialSlide]);
    const onClickCard = useCallback((heating_circuit_id) => {
        const index = config.findIndex(({ id }) => id == heating_circuit_id);
        if (index != -1) {
            setInitialSlide(index);
            open();
        }
    }, [setInitialSlide, open, config]);
    const component = useCallback((heating_circuit_config) => (_jsx(HeatingCircuitView, { config: heating_circuit_config, onClick: onClickCard })), [onClickCard]);
    const slide_component = useCallback((heating_circuit_config, drag_handler, onClose) => (_jsxs(Box, { display: "flex", flexDirection: "column", height: "100%", overflow: "hidden", children: [_jsx(SwipableModalHeader, { name: heating_circuit_config.name, onClose: onClose, drag_handler: drag_handler }), _jsx(HeatingCircuitView, { config: heating_circuit_config, lazy: true, children: _jsx(HeatingCircuitWidget, {}) })] }, heating_circuit_config.id)), []);
    return (_jsxs(_Fragment, { children: [_jsx(SortableCards, { panel_key: panel_key, list: config, component: component, min_height: 50 }), _jsx(SwiperWithModal, { opened: opened, onClose: onCloseSlider, component: slide_component, initialSlide: initial_slide, items: config })] }));
});
